<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap2">AUTHOR’S NOTE</h2>
<p class="noindentk123k">The story told here is true, the actors real people, the events actual happenings, all as close to an exact recounting of the facts as I have been able to come through hundreds of hours of interviewing and many hundreds more of research.</p>
<p class="indent">The reader should be aware, however, that of necessity certain elements of the story have been altered. Names have been changed, along with some elements of personal description, to protect the privacy of certain individuals, and to protect the legal rights of persons who have not been formally accused of crimes. Other details of cases are either absent from this account or altered because the police withhold them as an aid to the solution of the crimes; no criminal will find here details that will help him escape detection, and no damaged soul will find authoritative particulars for a false confession.</p>
<p class="indent">One other form of deviation from empirical fact should be mentioned. Where the thoughts of characters are reconstructed, it is done on the basis of those characters’ own recollections. Where the speech of characters is quoted, it is in some cases based on contemporary accounts, like newspaper stories, diaries, and meeting notes. In other cases it may be based on the memories of the speakers and of those who heard them speak. Since recording error, fallible memory, and the mysteries of the human spirit preclude exactitude, the author begs the reader’s indulgence for this exercise of artistic license.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// author_note.vue?2529a8e2